import PropTypes from 'prop-types';
import React from 'react';

import {Polyline} from 'common/components/BetterMap';

const WalkPath = ({start, end}) => (
  <Polyline
    path={[start, end]}
    strokeColor="rgba(0, 0, 0, 0)"
    icons={[
      {
        icon: {
          path: 'M 0,-2 0,2',
          strokeOpacity: 1,
          strokeColor: 'black',
          strokeWeight: 4,
          scale: 1,
        },
        repeat: '12px',
      },
    ]}
  />
);

WalkPath.propTypes = {
  start: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }),
  end: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }),
};

export default WalkPath;



// WEBPACK FOOTER //
// ./src/ondemand/components/WalkPath.js